import { Modal, Spin, Button, Empty } from 'antd'
import TableData from '../pages/Test/components/TableData'
import { saveCsv } from '../utils/csvUtils'
import { useState } from 'react'

const TableViewModal = ({ isModalVisible, isEditMode, isLoading, title, tableData, onConfirm, onCancel, downloadTable }) => {
  const [isDownloading, setIsDownloading] = useState(false)
  const handleDownload = async () => {
    setIsDownloading(true)
    const csvContent = await downloadTable()
    saveCsv(csvContent, title)
    setIsDownloading(false)
  }

  return (
    <Modal
      visible={isModalVisible}
      destroyOnClose
      onCancel={onCancel}
      footer={
        <>
          {isEditMode ? (
            <Button
              className='active-btn modal-btn'
              id='confirmBtn'
              onClick={onConfirm}
            >
              Confirm
            </Button>
          ) : (
            <>
            <Button
              className='active-btn modal-btn'
              disabled={isLoading || !(tableData?.headers?.length)}
              id='downloadBtn'
              onClick={handleDownload}
              loading={isDownloading}
            >
              Download
            </Button>
            <Button
              className='active-btn modal-btn'
              id='closeBtn'
              disabled={isLoading}
              onClick={onCancel}
            >Close</Button>
            </>
          )}
        </>
      }
      title={title}
      width='75%'
      className='table-modal'
    >
      {
        isLoading ? (
          <div className='flex justify-center mt-2'>
            <Spin tip='Loading' />
          </div>
        ) : tableData?.headers?.length ? (
          <div className='table-wrapper'>
            <TableData tableData={tableData} />
          </div>
        ) : (
          <div className='flex justify-center mt-2'>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )
      }
    </Modal>
  )
}

export default TableViewModal
